import { SxProps } from "@mui/material"

const accordionStyle: SxProps = {
  position: "relative",
  border: "1px solid #3ACF01",
  borderRadius: "0.3125rem",
  marginBottom: "1.75rem",
  "&.Mui-expanded, &.Mui-expanded:last-of-type": {
    margin: 0,
    marginBottom: "1.75rem",
  },
  "& .MuiAccordionSummary-root": {
    padding: "1.5rem 2.5rem 1.5rem",
    minHeight: 0,
    ".MuiAccordionSummary-content": {
      padding: 0,
      margin: 0,
    },
  },
  "& .MuiAccordionDetails-root": {
    position: "relative",
    padding: "10px 2.5rem 4rem 2.5rem",
  },
}

const ErrorSX: SxProps = {
  color: "#FF284D",
  fontSize: "10px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "12px",
  letterSpacing: "0.15px",
  pt: "5px",
}

const AntSwitchSX: SxProps = {
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#177ddc",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    // transition: theme.transitions.create(["width"], {
    //   duration: 200,
    // }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(255,255,255,.35)",
    boxSizing: "border-box",
  },
}

export { accordionStyle, ErrorSX, AntSwitchSX }
